import NodeCache from "node-cache"

const cache = new NodeCache({ stdTTL: 60 * 10, checkperiod: (60 * 10 * 6) / 5 }) //10 minutes cache

export default cache
